module.exports = __webpack_public_path__ + "img/Pulse-0.9s-144px.26420b23.svg";